import { AnyAction } from "redux";
import { Dispatch } from "react";
import { PageSetting, Query, Result } from "../../../../interfaces";
import { Find } from "../../../user";
import { Adapter } from "../../../../shared/adapter";
import { UsersAdapter } from "../../../../adapter/users-adapter";

export const FETCH_SEARCH_DATA_USERS_REQUEST = 'FETCH_SEARCH_DATA_USERS_REQUEST';
export const FETCH_SEARCH_DATA_USERS_SUCCESS = 'FETCH_SEARCH_DATA_USERS_SUCCESS';
export const FETCH_SEARCH_DATA_USERS_FAILURE = 'FETCH_SEARCH_DATA_USERS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataUsersRequest = () => {
    return {
        type: FETCH_SEARCH_DATA_USERS_REQUEST,
    };
};

const fetchDataUsersSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_SEARCH_DATA_USERS_SUCCESS,
        payload: data
    };
};

const fetchDataUsersFailure = (error: any) => {
    return {
        type: FETCH_SEARCH_DATA_USERS_FAILURE,
        payload: error,
    };
};


export const search = (page: number, pageSize: number, query: Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataUsersRequest());
        try {
            const response = await Find("users", query, page, PageSetting.limit);
            dispatch(fetchDataUsersSuccess(
                {
                    meta: response.meta,
                    values: Adapter.from(response.data).to((value) => new UsersAdapter(value).adapt())
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataUsersFailure(error.message));
        }
    };
};


